module.exports = __webpack_public_path__ + "img/ico-footer-wavve-on.d4912b54.svg";